import { forwardRef } from 'react';
import TextField, { TextFieldProps } from '../Inputs/TextField';
import styles from './index.module.scss';
import { InputBaseProps } from '@mui/material';

interface TextFieldType extends Omit<TextFieldProps, 'inputProps'> {
  inputProps?: InputBaseProps['inputProps'] & {
    inputclassname?: string;
    datacy?: string;
  };
}
export default forwardRef((params: TextFieldType, ref) => {
  const { inputclassname, datacy } = params?.inputProps || {};
  return (
    <TextField
      inputRef={ref}
      {...params}
      disabledClassName={styles.disabled}
      inputClassName={inputclassname}
      data-cy={datacy}
    />
  );
});
